import { FC } from 'react';
import { Image } from 'antd';
import { LOGO_MARK_WHITE, LOGO_WHITE } from '@/assets/brand';
import { LogoMark, LogoWrapper } from './Logo.styles';
import { LogoProps } from './Logo.types';

/** The Skyrise wordmark already carries the endorsement line, so it stands alone. */
const Logo: FC<LogoProps> = ({ collapsed }) => (
  <LogoWrapper $collapsed={collapsed}>
    {collapsed ? (
      <LogoMark>
        <Image src={LOGO_MARK_WHITE} width={26} preview={false} alt="Skyrise" />
      </LogoMark>
    ) : (
      <LogoMark>
        <Image src={LOGO_WHITE} width={110} preview={false} alt="Skyrise" />
      </LogoMark>
    )}
  </LogoWrapper>
);

export default Logo;
